import fallback from "../data/catalogue.json";

/* Catalogue is bundled with the site (static hosting — no server). To add or change
   products, edit src/data/catalogue.json and add the photo to public/products/<code>.jpg. */
export const displayName = (value = "") => value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

const DATA = {
  categories: fallback.categories.map((c) => ({
    ...c,
    cover: `/products/${(fallback.products.find((p) => p.category === c.slug) || {}).code}.jpg`,
    count: fallback.products.filter((p) => p.category === c.slug).length,
  })),
  products: fallback.products,
};

export function useCatalogue() {
  return DATA;
}
